import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ChangeDetectionStrategy, Component, effect, inject, OnInit, viewChild } from '@angular/core';
import { GuidelineService, GuidelineViewService, provideGuideline, ScrollService, TreeScrollService, ViewMode } from 'shared/domain';
import { SharedChaptersTreeComponent } from 'shared/feature-chapters-tree';
import {
  DrawerComponent,
  DrawerContainerComponent,
  DrawerContentComponent,
  DrawerImports,
  DrawerLeftDirective,
  SpinnerComponent,
} from 'shared/ui-common';
import { SmartbookGuidelinesStore } from 'smartbook/domain';

import { Ucum } from '@treetop/shared/model';

import { GuidelineReviewUpdateDialogService } from './guideline-review-update-dialog.service';
import { ReviewUpdateFooterComponent } from './review-update-footer/review-update-footer.component';
import { SmartbookContentComponent } from '../../../../../../../../guideline-page/src/lib/guideline-view/content/content.component';

export type GuidelineReviewUpdateDialogData = {
  guidelineUniqueId: string;
  revisionDate: Date | Ucum;
  updateMessage: string;
  sendEmailNotification: boolean;
  disableAllTags?: boolean;
  mode: ViewMode;
};

@Component({
  selector: 'tt-guideline-review-update-dialog',
  templateUrl: './guideline-review-update-dialog.component.html',
  styleUrls: ['./guideline-review-update-dialog.component.scss'],
  standalone: true,
  imports: [
    SpinnerComponent,
    ReviewUpdateFooterComponent,
    DrawerContainerComponent,
    DrawerComponent,
    SharedChaptersTreeComponent,
    DrawerContentComponent,
    CdkScrollable,
    DrawerImports,
    DrawerLeftDirective,
    SmartbookContentComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SmartbookGuidelinesStore, GuidelineReviewUpdateDialogService, provideGuideline(), GuidelineViewService, TreeScrollService],
})
export class GuidelineReviewUpdateDialogComponent implements OnInit {
  protected service = inject(GuidelineReviewUpdateDialogService);
  protected data = inject<GuidelineReviewUpdateDialogData>(DIALOG_DATA, { optional: true });
  protected guidelineService = inject(GuidelineService);
  protected guidelineViewService = inject(GuidelineViewService);
  protected dialogRef = inject(DialogRef);
  protected scrollService = inject(ScrollService);
  private treeScrollService = inject(TreeScrollService);

  private scrollable = viewChild(CdkScrollable);

  protected guidelineData = this.guidelineService.guidelineData;

  constructor() {
    effect(() => {
      const scrollable = this.scrollable();
      this.scrollService.init(scrollable);

      scrollable?.elementScrolled().subscribe((event: Event) => {
        this.treeScrollService.captureScrollEvent(event);
      });
    });
  }

  public ngOnInit(): void {
    if (this.data.guidelineUniqueId) {
      this.service.loadGuideline({ guidelineId: this.data.guidelineUniqueId, updateMessage: this.data.updateMessage ?? '' });
    }

    this.guidelineViewService.init({
      mode: this.data.mode,
      showTags: !this.data.disableAllTags,
    });
  }

  protected handlePublishButtonClicked() {
    const guideline = this.guidelineService.guideline;
    this.dialogRef.close(guideline);
  }
}
